
export const HeadingTags = [
    { id: 1, class: "", title: "h1. Bootstrap heading" },
    { id: 2, class: "", title: "h2. Bootstrap heading" },
    { id: 3, class: "", title: "h3. Bootstrap heading" },
    { id: 4, class: "", title: "h4. Bootstrap heading" },
    { id: 5, class: "", title: "h5. Bootstrap heading" },
    { id: 6, class: "", title: "h6. Bootstrap heading" },

]

export const CustomBlockquotes = [
    { id: 1, title: "Primary Blockquote Blockquote", color: "primary" },
    { id: 2, title: "Secondary Blockquote", color: "secondary" },
    { id: 3, title: "Warning Blockquote", color: "warning" },
    { id: 4, title: "Success Blockquote", color: "success" },
    { id: 5, title: "Info Blockquote", color: "info" },
    { id: 6, title: "Danger Blockquote", color: "danger" },
]